export function VerifiedBadge({ size = 18 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 18 18`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1.08887L2.25 3.54376V9.00012C2.25 15.1656 8.80005 16.8427 8.86597 16.8592L9 16.8916L9.13403 16.8592C9.19995 16.8427 15.75 15.1656 15.75 9.00012V3.54376L9 1.08887ZM14.625 9.00012C14.625 13.8819 9.89484 15.4727 9.0022 15.7292C8.14142 15.4744 3.375 13.8401 3.375 9.00012V4.33148L9 2.28638L14.625 4.33148V9.00012Z"
        fill="#2B74D8"
      />
      <path
        d="M6.02271 8.60254L5.22729 9.39795L7.875 12.0457L12.7727 7.14795L11.9773 6.35254L7.875 10.4548L6.02271 8.60254Z"
        fill="#2B74D8"
      />
    </svg>
  );
}
